// Column keys double as the backend sort keys (UserFilters::LIST_SORTABLE) so ResponsiveTable's
// sort arrows light up against `filters.sort` with no translation layer. Member No. and
// Financial Seasons are not sortable — matches the legacy DataTable definition.
//
// Edit / Login / Restore are separate columns (not merged into one "Actions" column) because the
// legacy page toggles them as a whole between the "Deleted" tab and every other tab (Edit+Login
// disappear, Restore appears) — see Members.vue's `onDeletedTabChange`.
export function buildColumns(isAdmin, isDeletedTab) {
  const columns = [
    { key: 'first_name', label: 'First Name', sortable: true, minWidth: '100px', width: '1.3fr' },
    { key: 'last_name', label: 'Last Name', sortable: true, minWidth: '130px', width: '2.4fr' },
    { key: 'member_number', label: 'Member No.', minWidth: '90px', width: '1.8fr' },
    { key: 'seasons', label: 'Financial Seasons', minWidth: '100px', width: '1.7fr' },
    { key: 'zone_id', label: 'Zone', sortable: true, minWidth: '60px', width: '0.6fr' },
    { key: 'beginning_of_year_status', label: 'BoY Status', sortable: true, minWidth: '90px', width: '1.4fr' }
  ]

  // Fixed px, not minWidth+fr (see Horses' `remove` column for why): each sized to the wider
  // of its header label and the shrunk .member-action-btn button, at the same padding/font-size
  // for all three, so the numbers scale with the word alone — "Edit" < "Login" < "Restore".
  if (isDeletedTab) {
    if (isAdmin) columns.push({ key: 'restore', label: 'Restore', width: '95px', cellClass: 'text-center' })
  } else {
    columns.push({ key: 'edit', label: 'Edit', width: '70px', cellClass: 'text-center' })
    if (isAdmin) columns.push({ key: 'login', label: 'Login', width: '75px', cellClass: 'text-center' })
  }

  return columns
}

// Below 930px the row collapses into an accordion: a combined First+Last name summary (the
// legacy expandedHeader showed both names together) plus the same detail fields the legacy
// expandedRow showed (Member No, Financial Seasons, Zone, BoY Status, Login).
//
// 930, not the ~852px the full grid's columns actually need (every column's minWidth/fixed
// width floor + cell padding + borders, widest case: admin, active tab, 8 columns incl.
// Edit/Login) — because NavbarSide.vue's sidebar is `position: absolute` (an overlay, costs
// the row 0px) below 1024px viewport width but a static `flex: 0 1 220px` column at 1024px
// and up. Container width therefore tracks the viewport 1:1 up to ~925px (viewport 1023, just
// under the sidebar's own breakpoint) and then drops by roughly 220px the moment the sidebar
// stops overlaying — so 852-920 left a ~5-10px viewport gap (observed at 1019-1023px) where
// the container was briefly wide enough for the full grid, sandwiched between accordion mode
// on both sides. 930 sits above that ~925px ceiling so the accordion is continuous across the
// gap instead of flashing back to the desktop grid for a few pixels. Recompute both numbers if
// columns are added/resized, or if NavbarSide's breakpoint or sidebar width changes.
export function buildBreakpoints(isAdmin, isDeletedTab) {
  const rows = [
    ['member_number'],
    ['seasons'],
    ['zone_id'],
    ['beginning_of_year_status']
  ]

  if (isDeletedTab) {
    if (isAdmin) rows.push(['restore'])
  } else if (isAdmin) {
    rows.push(['login'])
  }

  return [
    {
      maxWidth: 930,
      hideHeader: true,
      accordion: {
        summary: [{ keys: ['name'], hideLabel: true }]
      },
      rows
    }
  ]
}

export const FINANCIAL_TABS = [
  { value: 'all', label: 'All' },
  { value: '1', label: 'Financial' },
  { value: '0', label: 'Unfinancial' },
  { value: 'Volunteer', label: 'Volunteer' }
]

export const MEMBERSHIP_STATUS_TABS = [
  { value: 'all', label: 'All' },
  { value: 'Onhold', label: 'On Hold' },
  { value: 'Archived', label: 'Archived' },
  { value: 'Lifetime', label: 'Lifetime' },
  { value: 'Suspended', label: 'Suspended' },
  { value: 'Deleted', label: 'Deleted' }
]



// WEBPACK FOOTER //
// ./src/views/Members/Listing/columns.js